"use client";

import { HomepageHeader } from "@/components/homepage/homepage-header";
import { HeroSection } from "@/components/homepage/hero-section";
import { WhatIsSection } from "@/components/homepage/what-is-section";
import { StepsSection } from "@/components/homepage/steps-section";
import { SuggestionListsSection } from "@/components/homepage/suggestion-lists-section";
import { DuoCtaSection } from "@/components/homepage/duo-cta-section";
import { InfoCenterSection } from "@/components/homepage/info-center-section";
import { NewsletterSection } from "@/components/homepage/newsletter-section";
import { NewsletterFooterBand } from "@/components/homepage/newsletter-footer-band";
import { HomepageFooter } from "@/components/homepage/homepage-footer";
import { HelpModal } from "@/components/homepage/help-modal";
import { useScrollEffects } from "@/components/homepage/use-scroll-effects";
import type { SuggestionTemplateCard } from "@/lib/create-list/suggestion-templates";

/**
 * Public homepage — the product's single entry point (Tech Spec · Homepage Lista).
 *
 * Composition only, plus two wrapper concerns: the entry fade is CSS alone (`tb-entry-fade`), so
 * the page is visible without script, and `overflow: clip` stops the scaled parallax layers from
 * extending the document past the footer.
 */
export function Homepage({ suggestionLists }: { suggestionLists: readonly SuggestionTemplateCard[] }) {
  const { circleRef, heroStageRef, rootRef, scrollToSection, setScrollLocked } =
    useScrollEffects();

  return (
    <HelpModal>
      <div
        ref={rootRef}
        className="tb-entry-fade tb-editorial-body relative overflow-clip bg-[var(--tb-white)] text-[var(--fg)]"
      >
        <HomepageHeader onScrollLockChange={setScrollLocked} onSectionNavigate={scrollToSection} />
        <main>
          <HeroSection heroStageRef={heroStageRef} />
          <WhatIsSection />
          <StepsSection />
          <SuggestionListsSection lists={suggestionLists} />
          <DuoCtaSection />
          <InfoCenterSection />
        </main>
        <NewsletterFooterBand circleRef={circleRef}>
          <NewsletterSection />
          <HomepageFooter />
        </NewsletterFooterBand>
      </div>
    </HelpModal>
  );
}
